import React from 'react';
import axios from 'axios';
import * as Sentry from "@sentry/nextjs";
import { useCalendlyEventListener, InlineWidget } from 'react-calendly';

const Calendly = ({ link, dealID }) => {
  useCalendlyEventListener({
    onEventScheduled: async (e) => {
      const eventURL = e.data.payload.event.uri;
      const inviteeURL = e.data.payload.invitee.uri;
      const values = {
        event: eventURL,
        invitee: inviteeURL,
      };
      try {
        await axios.post(`${process.env.NEXT_PUBLIC_ROTA_URL}paid-con-booking`, values);
      } catch (error) {
        console.error('There was an error with the API call:', error);
        Sentry.captureException(error, {
          tags: { page: "Calendly" },
          extra: {
            description: "Failed to process Calendly event",
            context: values,
          },
        });
      }
    },
  });

  const deal = dealID ? `?salesforce_uuid=${dealID}` : '';

  return (
    <div className="calendly">
      <InlineWidget url={`https://calendly.com/${link}${deal}`} />
    </div>
  );
};

export default Calendly;
